ACC.forgotpassword = {
  bindAll: function() {
    this.bindForgotPasswordLink($('.password-forgotten'));
  },
  showError: function() {
    var imageMinHeight = 'ph-image-minheight',
        bannerImagelogin = '.ph-Login__bannerimg',
        imageContLogin = '.ph-image-minheight',
        loginPageLabel = '.pageLabel-login',
        loginPanelContentHeight = 0;


    if (($(loginPageLabel).find('.negative').length > 0) && $(bannerImagelogin).length > 0) {
      $('.ph-image-sectionNew').addClass(imageMinHeight);
      $(bannerImagelogin).addClass(imageMinHeight);
      loginPanelContentHeight = $(loginPageLabel).find('.login-panel').outerHeight();
      $(imageContLogin).css('height', loginPanelContentHeight + 150);
      $(bannerImagelogin).css('max-height', loginPanelContentHeight + 150);
    }

    if (($(loginPageLabel).find('.negative').length === 0) && $(bannerImagelogin).length > 0) {
      loginPanelContentHeight = $(loginPageLabel).find('.login-panel').outerHeight();
      $('.ph-image-sectionNew').css('height', loginPanelContentHeight + 150);
      $(bannerImagelogin).css('height', loginPanelContentHeight + 150);
      $(bannerImagelogin).css('max-height', loginPanelContentHeight + 150);
    }
  },

  bindForgotPasswordLink: function(link) { /* eslint-disable xss/no-mixed-html*/
    link.click(function() {
      $.get(link.data('url')).done(function(data) {
      /* eslint-disable no-use-before-define*/
        var cboxWidth = getCboxWidth();

        /* eslint-enable no-use-before-define*/
        $.colorbox({
          html: data,
          maxWidth: cboxWidth,
          overlayClose: false,
          onOpen: function() {
            $('#validEmail').remove();
          },
          onComplete: function() {
            var $forgottenPwdForm = $('#forgottenPwdForm');

            $forgottenPwdForm.ajaxForm({
              /* eslint-enable xss/no-mixed-html*//* eslint-disable no-shadow*/
              success: function(data) {
                /* eslint-enable no-shadow */
                /* eslint-disable unicorn/explicit-length-check*/
                if ($(data).closest('#validEmail').length) {
                  /* eslint-enable unicorn/explicit-length-check*/
                  if ($('#validEmail').length === 0) {
                    $('#globalMessages').append(data);

                    if ($(window).width() > 960) {
                      ACC.forgotpassword.showError();
                    }
                  }

                  $.colorbox.close();
                } else {
                  $forgottenPwdForm.find('.form_field-elements').html($(data).find('#forgottenPwdForm .form_field-elements'));
                  $.colorbox.resize();
                }
              }
            });
            ACC.common.refreshScreenReaderBuffer();
          },
          onClosed: function() {
            ACC.common.refreshScreenReaderBuffer();
          }
        });
      });
    });
  }
};


$(document).ready(function() {
  ACC.forgotpassword.bindAll();

  if ($(window).width() > 960) {
    ACC.forgotpassword.showError();
  }
});

/* eslint-disable no-implicit-globals*/
function getCboxWidth() {
  var maxWid = '785px';

  if ($(window).width() < 400) {
    maxWid = '250px';
  } else if ($(window).width() < 780) {
    maxWid = '350px';
  } else if ($(window).width() < 900) {
    maxWid = '600px';
  } else if ($(window).width() > 900) {
    maxWid = '785px';
  }

  /* eslint-enable no-implicit-globals*/
  return maxWid;
}
